import Routes from 'routes/Routes';

export default Routes;
